import { Box, Href, Icon, Text } from '@factorialco/deprecated-design-system'
import { PostDataFragment } from 'generated/resources/graphql'

type PostAttachment = PostDataFragment['savedAttachmentsConnection']['edges'][number]['node']

interface Props {
  attachment: PostAttachment
}

const AttachedFile = ({ attachment }: Props) => (
  <Box paddingRight="s16" paddingTop="s16">
    <Href href={attachment.url} target="_blank" download>
      <Box
        flexDirection="row"
        alignItems="center"
        justifyContent="spaceBetween"
        gap="s16"
        borderRadius={{ all: 'abs008' }}
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        padding="s12"
      >
        <Icon.Medium icon="file-filled" />
        <Box flexGrow flexDirection="row" alignItems="center" gap="s16">
          <Text.Normal size="200" color="grey800" ellipsis>
            {attachment.filename}
          </Text.Normal>
        </Box>
        <Icon.Medium icon="download" />
      </Box>
    </Href>
  </Box>
)

export default AttachedFile
